import api from '../api'

export default {

  engagements: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/engagements?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

 
  createGetData: async (withStakeholder)=> {
    if(withStakeholder){
      return api.get('api/engagements/create?stakeholders=true')
    }else{
      return api.get('api/engagements/create')
    }

  },

  create: async engagement => {
    return api.post('api/engagements', engagement)
  },



  get: async id => {
    return api.get('api/engagements/' + id)
  },

  update: async (id,engagement) => {
    return api.put('api/engagements/' + id, engagement)
  },

  delete: async id => {
    return api.delete('api/engagements/' + id)
  },


  checkIn: async (id,engagement) => {
    return api.post('api/engagements/' + id + '/check-in', engagement)
  },

  checkOut: async (id,engagement) => {
    return api.post('api/engagements/' + id + '/check-out', engagement)
  },

}
